// extracted by mini-css-extract-plugin
export default {"separator":"index_separator__sB5lk","bull":"index_bull__Sks4t"};